import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Auth
export const login = (username, password) => 
  api.post('/auth/login', { username, password });

// Hotels
export const getHotels = () => api.get('/hotels');
export const getHotel = (hotelId) => api.get(`/hotels/${hotelId}`);
export const getCabin = (hotelId, cabinId) => api.get(`/hotels/${hotelId}/cabins/${cabinId}`);

// Meals
export const getMeals = () => api.get('/meals');

// Guests
export const createGuest = (guestData) => api.post('/guests', guestData);
export const getActiveGuest = (hotelId, cabinId) => api.get(`/guests/${hotelId}/${cabinId}`);
export const updateGuest = (guestId, guestData) => api.put(`/guests/${guestId}`, guestData);

// Reservations
export const createReservation = (reservationData) => api.post('/reservations', reservationData);
export const getReservations = (params) => api.get('/reservations', { params });
export const cancelReservation = (reservationId) => api.delete(`/reservations/${reservationId}`);
export const adminDeleteReservation = (reservationId) => api.delete(`/admin/reservations/${reservationId}`);

// Kitchen
export const getKitchenMeals = (date) => api.get('/kitchen/meals', { params: { date } });

// Admin
export const getCheckoutNotifications = () => api.get('/admin/checkout-notifications');
export const getAllReservations = (params) => api.get('/admin/all-reservations', { params });
export const getAdminStats = () => api.get('/admin/stats');
export const getQRData = () => api.get('/admin/qr-data');

// Tours
export const getTours = () => api.get('/tours');
export const getTour = (tourId) => api.get(`/tours/${tourId}`);
export const getPaypalInfo = () => api.get('/tours/paypal-info');
export const createTourReservation = (data) => api.post('/tours/reserve', data);
export const getGuestTourReservations = (guestId) => api.get(`/tours/reservations/guest/${guestId}`);
export const cancelTourReservation = (reservationId) => api.delete(`/tours/reservations/${reservationId}`);

// Tour file uploads
export const uploadPassport = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/uploads/passport', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// Admin Tours
export const getAdminTourReservations = (params) => api.get('/admin/tours/reservations', { params });
export const updateTourReservation = (reservationId, data) => api.put(`/admin/tours/reservations/${reservationId}`, data);
export const updateTourAvailability = (tourId, available) => api.put(`/admin/tours/availability/${tourId}`, { available });
export const getTourStats = () => api.get('/admin/tours/stats');

// Bird Brain Bungalows Guest Management
export const getBirdBrainGuests = () => api.get('/admin/bird-brain-guests');

export default api;
